export default {
    label_task:{
        en:"Upazilas",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Upazila",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Upazila",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Upazila",
        bn:'ব্যবহারকারীর বিবরণ'
    },
}